<template>
  <section v-if="breakdowns.length" class="wallet-funds-breakdown" :aria-label="$t('dashboard.fundsBreakdown')">
    <div v-for="item in breakdowns" :key="item.currency" class="wallet-funds-breakdown__group">
      <div class="wallet-funds-breakdown__row">
        <span>{{ $t('dashboard.lockedBalance') }}</span>
        <strong>{{ formatAmount(item.investmentLocked) }} {{ item.currency }}</strong>
      </div>
      <div v-if="item.withdrawalPrincipal != 0" class="wallet-funds-breakdown__row">
        <span>{{ $t('dashboard.withdrawalPrincipalPending') }}</span>
        <strong>{{ formatAmount(item.withdrawalPrincipal) }} {{ item.currency }}</strong>
      </div>
      <div v-if="item.withdrawalFee != 0" class="wallet-funds-breakdown__row">
        <span>{{ $t('dashboard.withdrawalFeePending') }}</span>
        <strong>{{ formatAmount(item.withdrawalFee) }} {{ item.currency }}</strong>
      </div>
      <div v-if="item.withdrawalTotal != 0" class="wallet-funds-breakdown__row wallet-funds-breakdown__row--total">
        <span>{{ $t('dashboard.withdrawalTotalPending') }}</span>
        <strong>{{ formatAmount(item.withdrawalTotal) }} {{ item.currency }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WalletFundsBreakdown',
  props: {
    wallets: { type: Array, default: () => [] },
    withdrawals: { type: Array, default: () => [] },
  },
  computed: {
    breakdowns() {
      const groups = new Map();
      const getGroup = (currencyCode) => {
        const code = String(currencyCode || '').trim().toUpperCase();
        if (!['USD', 'USDT'].includes(code)) return null;
        const key = 'USD';
        if (!groups.has(key)) {
          groups.set(key, {
            currency: key === 'USD' ? 'USD / USDT' : key,
            investmentLocked: 0,
            withdrawalPrincipal: 0,
            withdrawalFee: 0,
            withdrawalTotal: 0,
          });
        }
        return groups.get(key);
      };

      this.wallets.forEach((wallet) => {
        const group = getGroup(wallet.currency_code);
        if (group) group.investmentLocked += Number(wallet.locked_balance || 0);
      });

      this.withdrawals
        .filter((withdrawal) => Number(withdrawal.status) === 2)
        .forEach((withdrawal) => {
          const group = getGroup(withdrawal.currency);
          if (!group) return;
          const principal = Number(withdrawal.amount || 0);
          const fee = Number(withdrawal.fee_amount || 0);
          group.withdrawalPrincipal += principal;
          group.withdrawalFee += fee;
          group.withdrawalTotal += Number(withdrawal.total_debited || (principal + fee));
        });

      return Array.from(groups.values());
    },
  },
  methods: {
    formatAmount(value) {
      const amount = Number(value || 0);
      if (!Number.isFinite(amount)) return '0';
      const locale = this.$i18n?.locale === 'fa' ? 'fa-IR' : 'en-US';
      return new Intl.NumberFormat(locale, { maximumFractionDigits: 8 }).format(amount);
    },
  },
};
</script>

<style scoped>
.wallet-funds-breakdown {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(127, 114, 156, 0.2);
  color: inherit;
}

.wallet-funds-breakdown h4 {
  margin: 0 0 8px;
  color: inherit;
  font-size: 0.82rem;
}

.wallet-funds-breakdown__group + .wallet-funds-breakdown__group {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(127, 114, 156, 0.12);
}

.wallet-funds-breakdown__currency {
  margin-bottom: 3px;
  font-size: 0.72rem;
  opacity: 0.9;
}

.wallet-funds-breakdown__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 0;
  font-size: 0.72rem;
  line-height: 1.6;
}

.wallet-funds-breakdown__row span {
  min-width: 0;
  opacity: 0.76;
}

.wallet-funds-breakdown__row strong {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
  text-align: end;
}


.wallet-funds-breakdown__note {
  margin: 7px 0 0;
  font-size: 0.68rem;
  line-height: 1.6;
  opacity: 0.72;
}
</style>
